import PropTypes from 'prop-types';
import React from 'react';
import styles from 'js/pages/TreatmentPage/ContentSection.module.css';
import gridStyles from 'assets/style/grid.module.css';

const ContentSection = ({ children, ...otherProps }) => (
  <div className={styles.wrapper} {...otherProps}>
    <div className={styles.newSection}>
      <div className={gridStyles.row}>{children}</div>
    </div>
  </div>
);

ContentSection.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ContentSection;
